module.exports = '4.11.1';



// WEBPACK FOOTER //
// ./src/version.js